(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-geolocation"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-language-geolocation]');
  if (!config || window.__sofiaLanguageInitialized) return;
  window.__sofiaLanguageInitialized = true;

  const preferenceKey = 'st_language_preference_v1';
  const countryPreferenceKey = 'st_country_preference_v1';
  const visitKey = 'st_language_visit_v1';
  const attemptKey = 'st_language_attempt_v1';
  const supported = config.dataset.languages.split(',');
  const countries = config.dataset.countries.split(',');
  const current = config.dataset.locale;
  const currentCountry = config.dataset.country;
  const autoForm = config.querySelector('form');
  const pageURL = new URL(window.location.href);
  const isLanguage = (value) => ['it', 'en'].includes(value) && supported.includes(value);
  const returnPath = () => window.location.pathname + window.location.search + window.location.hash;
  const readPreference = () => {
    try {
      const value = document.cookie.split('; ').find((part) => part.startsWith(preferenceKey + '='));
      return value ? value.slice(preferenceKey.length + 1) : '';
    } catch { return ''; }
  };
  const readCountryPreference = () => {
    try {
      const value = document.cookie.split('; ').find((part) => part.startsWith(countryPreferenceKey + '='));
      return value ? value.slice(countryPreferenceKey.length + 1) : '';
    } catch { return ''; }
  };
  const rememberPreference = (language) => {
    try {
      document.cookie = `${preferenceKey}=${language}; Path=/; Max-Age=15552000; SameSite=Lax; Secure`;
    } catch {}
  };
  const readSession = (key) => {
    try { return window.sessionStorage.getItem(key); } catch { return null; }
  };
  const writeSession = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
      return window.sessionStorage.getItem(key) === value;
    } catch { return false; }
  };
  const setReturnPath = (form) => {
    const field = form.querySelector('[name="return_to"]');
    if (field) field.value = returnPath();
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form === autoForm || !form.matches('form[action$="/localization"]')) return;
    setReturnPath(form);
    const submitter = event.submitter;
    const field = form.querySelector('select[name="locale_code"], input[name="locale_code"], select[name="language_code"], input[name="language_code"]');
    const language = ['locale_code', 'language_code'].includes(submitter?.name) ? submitter.value : field?.value;
    if (isLanguage(language)) {
      rememberPreference(language);
      writeSession(visitKey, '1');
      writeSession(attemptKey, '');
    }
    const country = form.querySelector('select[name="country_code"], input[name="country_code"]')?.value;
    if (countries.includes(country)) {
      document.cookie = `${countryPreferenceKey}=${country}; Path=/; Max-Age=15552000; SameSite=Lax; Secure`;
    }
  }, true);

  if (!autoForm || !supported.includes('it') || !supported.includes('en')) return;
  if (window.Shopify?.designMode || pageURL.searchParams.has('preview_theme_id')) return;
  if (['cart', 'password', '404'].includes(config.dataset.pageType)) return;
  if (/(?:^|\/)(?:checkouts?|account|challenge)(?:\/|$)/.test(pageURL.pathname)) return;
  if (/bot|crawl|spider|slurp|facebookexternalhit|facebot|pinterest|google-inspectiontool|lighthouse/i.test(navigator.userAgent)) return;

  let interacted = false;
  const stopRedirect = () => { interacted = true; };
  document.addEventListener('pointerdown', stopRedirect, { once: true, passive: true });
  document.addEventListener('keydown', stopRedirect, { once: true });
  document.addEventListener('submit', stopRedirect, { once: true, capture: true });

  const selectLocalization = (language, country = currentCountry) => {
    if (!isLanguage(language) || !countries.includes(country) || interacted || document.visibilityState === 'hidden') return;
    if (language === current && country === currentCountry) return;
    const attempt = `${language}:${country}`;
    if (readSession(attemptKey) === attempt || !writeSession(attemptKey, attempt)) return;
    setReturnPath(autoForm);
    autoForm.querySelector('[name="locale_code"]').value = language;
    autoForm.querySelector('[name="country_code"]').value = country;
    HTMLFormElement.prototype.submit.call(autoForm);
  };

  const preference = readPreference();
  if (isLanguage(preference)) {
    if (preference === current) writeSession(attemptKey, '');
    else { selectLocalization(preference); return; }
  }
  const firstVisit = !readSession(visitKey) && writeSession(visitKey, '1');
  if (!firstVisit && (currentCountry === 'GB' || readCountryPreference() || !countries.includes('GB'))) return;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  const root = config.dataset.root.replace(/\/?$/, '/');
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin',
    signal: controller.signal,
    headers: { Accept: 'application/json' },
  })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      const country = data?.detected_values?.country?.handle;
      if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country) || ['XX', 'ZZ'].includes(country)) return;
      const detectedCountry = country === 'GB' && countries.includes('GB') && !readCountryPreference() ? 'GB' : currentCountry;
      const language = isLanguage(preference) ? preference : firstVisit ? (country === 'IT' ? 'it' : 'en') : current;
      selectLocalization(language, detectedCountry);
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
  } catch(e) { console.error(e); }
})();

})();
